export function getPublicRecipesPath() {
  return "/recipes";
}

export function getPublicRecipePath(recipe) {
  const slug = String(recipe?.slug || "").trim();
  const fallbackId = recipe?.id == null ? "" : String(recipe.id);
  const detail = encodeURIComponent(slug || fallbackId);
  return detail ? `${getPublicRecipesPath()}/${detail}` : getPublicRecipesPath();
}

export function getUserRecipesPath(_username) {
  return "/my-recipes";
}